import request from '../utils/request';
import { buildApiPayload } from '../utils/api';

export function getReports(params, signal) {
  return request({
    url: '/report',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function deleteReport(uuid) {
  return request({
    url: `/report/${uuid}`,
    method: 'delete',
  });
}

export function downloadReport(uuid, signal, onProgress) {
  return request({
    url: `/report/${uuid}/download`,
    method: 'get',
    responseType: 'arraybuffer',
    signal,
    onProgress,
  });
}
